import { render } from "./footer-sections-list.vue?vue&type=template&id=419fa510&scoped=true"
import script from "./footer-sections-list.vue?vue&type=script&lang=js"
export * from "./footer-sections-list.vue?vue&type=script&lang=js"

import "./footer-sections-list.vue?vue&type=style&index=0&id=419fa510&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419fa510"],['__file',"src/components/notepad/parts/footer-sections-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "419fa510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('419fa510', __exports__)) {
    api.reload('419fa510', __exports__)
  }
  
  module.hot.accept("./footer-sections-list.vue?vue&type=template&id=419fa510&scoped=true", () => {
    api.rerender('419fa510', render)
  })

}


export default __exports__